import "../../assets/styles/InfoUser.css";
import React, { useState } from "react";

const REQUEST_TYPES = {
  full_name: "Thay đổi họ và tên",
  phone_number: "Thay đổi số điện thoại",
  email: "Thay đổi email",
  bank: "Thay đổi tài khoản ngân hàng",
  usdt: "Liên kết ví USDT",
  birthday: "Thay đổi ngày sinh",
  forget_password: "Cấp lại mật khẩu đăng nhập",
  forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
};

function DataConfirm({ user, webSetting }) {
  const [copySuccess, setCopySuccess] = useState("");
  const requestType = REQUEST_TYPES[user.update_type] || user.update_type;
  const content = `Tên đăng nhập: ${user.account}\r\nMã yêu cầu: ${user.request_code || ""}`;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const copyContent = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopySuccess("Đã sao chép nội dung.");
      setTimeout(() => setCopySuccess(""), 30000);
      if (user.send_type === "phone_number" && isMobile) window.location.href = `sms:${webSetting?.phone_number}?body=${encodeURIComponent(content)}`;
    } catch (error) {
      setCopySuccess("Không thể sao chép nội dung.");
    }
  };

  const title = requestType.toUpperCase();
  const mailLink = isMobile
    ? `mailto:${webSetting?.email}?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(content)}`
    : `https://mail.google.com/mail/?view=cm&fs=1&to=${webSetting?.email}&su=${encodeURIComponent(title)}&body=${encodeURIComponent(content)}`;

  return (
    <div className="content-text-confirm">
      <div className="request-confirm-info">
        <div className="item-info"><p className="label-info">Yêu cầu:</p><p className="info-text">{requestType}</p></div>
        <div className="item-info"><p className="label-info">Tên đăng nhập:</p><p className="info-text">{user.account}</p></div>
        <div className="item-info"><p className="label-info">Mã yêu cầu:</p><p className="info-text request-code-full">{user.request_code}</p></div>
      </div>
      {user.update_type === "forget_password_withdraw" && <p className="request-code-reminder">Vui lòng lưu mã yêu cầu để tra cứu kết quả khi cần.</p>}
      <div className="box-footer">
        <div className="btn-copy-text"><button onClick={copyContent}>Sao chép nội dung</button>{copySuccess && <p className="ss-copy">{copySuccess}</p>}</div>
        {user.send_type === "email" ? <div className="btn-send type-send"><a href={mailLink} target="_blank" rel="noopener noreferrer">Gửi Email</a></div>
          : isMobile && user.send_type === "phone_number" && <div className="btn-send type-send"><a href={`sms:${webSetting?.phone_number}?body=${encodeURIComponent(content)}`}>Gửi Tin Nhắn</a></div>}
      </div>
    </div>
  );
}

export default DataConfirm;
